import React from "react";

// Importing child component `Options`
import Options from "./Options";

// `AdvanceSelector` component definition
export default function AdvanceSelector({
  className,
  className2,
  data,
  name,
  id,
  label,
  enable,
  handleChange,
  value,
  advance_selector_class=true
}) {
  return (
    <div className={className}>
      {/* Label for the select element */}
      <label htmlFor={`${id}`} className="form-labels">{label}</label>

      <div className={className2}>
        <select
          className={`form-select inputs ${advance_selector_class ? 'advance-selector' : ''}`}
          name={name}
          id={id}
          onChange={handleChange}
          value={value}
          disabled={enable ? "" : "disabled"} // Conditionally disable the select element based on `enable` prop
        >
          {/* Default option prompting user to choose */}
          <option value={0}>Choose an option</option>

          {/* Map through `data` array to render `Options` components with unique `key` and `keyValue` */}
          {data.map(function (d, i) {
            return <Options keyValue={i} key={i} id={d.id} name={d.name} preview={d.preview} />;
          })}
        </select>
      </div>
    </div>
  );
}
